module.exports = __webpack_public_path__ + "static/media/bmmilogoImage.35f92a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bmmilogoImage.png
// module id = 305
// module chunks = 0